export default class Globals {
	static getBaseUrl() {
		try {
			App
		} catch (e) {
			return "/"
		}
		return App.Env.BaseUrl;
	}

}

Globals.API_KEY = "WEB.0.0";

// Mostra nella console i dati di tracking 
Globals.SHOW_TRACKING_DATA = false;

// Mostra nella console le chiamate del service manager
Globals.SERVICE_MANAGER_SHOW_CALLS = false;

// Esclude totalmente il processo fake
Globals.SERVICE_MANAGER_USE_FAKE = true